export const columns = [
  {
    field: 'createdBy',
    headerName: 'User',
    flex: 1,
    sortable: true,
  },
  {
    field: 'type',
    headerName: 'Action type',
    flex: 1,
    sortable: true,
    cellClassName: 'bold-text',
  },
  {
    field: 'isSuccessful',
    headerName: 'Status',
    flex: 1,
    sortable: true,
  },
  {
    field: 'entityId',
    headerName: 'Vaulting Request Id',
    flex: 1,
    sortable: true,
  },
  {
    field: 'createdOn',
    headerName: 'Date/Time',
    flex: 1,
    sortable: true,
    type: 'dateTime',
  },
  {
    field: 'details',
    headerName: 'Details',
    flex: 1,
    sortable: true,
  },
];

export const userActTypes = [
  {
    filterValue: 'Contact update',
    value: 'CONTACT_UPDATE',
  },
  {
    filterValue: 'Contact delete',
    value: 'CONTACT_DELETE',
  },
  {
    filterValue: 'Contact create',
    value: 'CONTACT_CREATE',
  },
  {
    filterValue: 'Vaulting Request submit',
    value: 'VAULT_REQUEST_CREATE',
  },
  {
    filterValue: 'Vaulting Request delete',
    value: 'VAULT_REQUEST_DELETE',
  },
  {
    filterValue: 'Vaulting Request activate',
    value: 'VAULT_REQUEST_ACTIVATE',
  },
  {
    filterValue: 'Vaulting Request de-activate',
    value: 'VAULT_REQUEST_DEACTIVATE',
  },
  {
    filterValue: 'Vaulting Request update',
    value: 'VAULT_REQUEST_UPDATE',
  },
  {
    filterValue: 'Email send',
    value: 'SEND_EMAIL',
  },
];

export const userActStatuses = [
  {
    filterValue: 'Success',
    value: true,
  },
  {
    filterValue: 'Failed',
    value: false,
  },
];

export const pageSize = 20;
